<template>
  <footer class="footer">
    <div
      class="copyright clearfix content-main"
      v-if="!$store.state.env.isMobile"
    >
      <div class="pull-right">
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >沪ICP备17047194号-5</a
        >
        &nbsp;
        <img
          src="https://image.benq.com.cn/is/image/benqco/police?$ResponsivePreset$&amp;fmt=png-alpha"
          alt="苏公网安备 32050502000550号"
        />
        <a
          style="margin-left: 3px"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050502000550"
          target="_blank"
          >苏公网安备 32050502000550号</a
        >
        &nbsp;|&nbsp;&nbsp;©copyright 2020 明基智能科技（上海）有限公司
      </div>
    </div>
    <div class="copyright-mobile" v-else>
      <p>©copyright 2020 明基智能科技（上海）有限公司.</p>
      <p>
        <a href="https://beian.miit.gov.cn/">沪ICP备17047194号-5</a>
      </p>
      <p>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050502000550"
          ><img
            src="https://image.benq.com.cn/is/image/benqco/police?$ResponsivePreset$&amp;fmt=png-alpha"
            alt="苏公网安备 32050502000550号"
          />苏公网安备 32050502000550号</a
        >
      </p>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
};
</script>
<style lang="scss" scoped>
.copyright {
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid $color-border-base;
  font-size: 12px;
  text-align: center;
}
.pull-right {
  margin: 0 auto;
  
  color: $color-text-regular;
  img,
  a {
    vertical-align: middle;
  }
  a {
    color: $color-text-regular;
  }
  img {
    width: 20px;
    height: 20px;
  }
}
.copyright-mobile {
  padding: 11px 0;
  border-top: 1px solid $color-border-base;
  font-size: 12px;
  font-weight: 400;
  color: $color-text-regular;
  text-align: center;
  p {
    height: 15px;
    line-height: 15px;
  }
  a {
    color: $color-text-regular;
    > img {
      margin-right: 3px;
      height: 11px;
      vertical-align: -1.5px;
    }
  }
}
</style>
